import { createFileRoute } from "@tanstack/react-router"
import SessionType from "@/app/settings/analysis-groups/sessions/page"

export const Route = createFileRoute("/settings/analysis-groups/sessions")({
  component: SessionType,
})
